// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"05a6536361eefecf1697","293":"53d08a05675f827b5a85","518":"79dd1f0ac54d8a18fbe7","779":"98c684b849858f09e28f"}[chunkId] + ".js";
};